module.exports = __webpack_public_path__ + "img/repair-tools.8dfed1bd.svg";